import { ReactElement } from 'react';
import { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from 'common/components/antd/Button/Button';
import { Space } from 'common/components/antd/Space/Space';
import { ROUTES_MAPPING } from 'navigation/constants/route.constants';
import { ReactComponent as Checkmark } from 'assets/ibm/checkmark--filled.svg';
import { ReactComponent as Close } from 'assets/ibm/close--filled.svg';
import { SContainer, SIconWrapper, SText } from './payment-status.page.style';

const SUCCESS_COLOR = '#6bc426';
const FAIL_COLOR = '#c42222';

const makeHumanReadableError = (errStr: string, t: TFunction): string => {
  if (errStr.includes('underfunded')) return t('paymentOperation.status.error.underfunded');
  if (errStr.includes('insufficient')) return t('paymentOperation.status.error.insufficient');
  return t('paymentOperation.status.error.common');
};

const PaymentStatusPage = (): ReactElement => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { state } = useLocation();
  const isSuccess = state?.status === 'success';
  const errorStr = String(searchParams.get('error'));
  const humanReadableError = makeHumanReadableError(errorStr, t);

  return (
    <SContainer>
      <SIconWrapper>
        {isSuccess ? (
          <Checkmark
            style={{
              color: SUCCESS_COLOR,
            }}
          />
        ) : (
          <Close
            style={{
              color: FAIL_COLOR,
            }}
          />
        )}
      </SIconWrapper>
      <SText>{isSuccess ? t('paymentOperation.status.paymentSuccess') : humanReadableError}</SText>
      <div
        style={{
          marginTop: 29,
        }}
      >
        <Space size={10}>
          <Button
            type="primary"
            onClick={(): void => {
              navigate(ROUTES_MAPPING.PROTECTED.DASHBOARD);
            }}
          >
            {t('paymentOperation.status.button.primary')}
          </Button>
          <Button
            onClick={(): void => {
              navigate(ROUTES_MAPPING.PROTECTED.PAYMENT_OPERATION, {
                state: state?.data,
              });
            }}
          >
            {t('paymentOperation.status.button.secondary')}
          </Button>
        </Space>
      </div>
    </SContainer>
  );
};

export default PaymentStatusPage;
